import { laboratoryTestSelectionLookupQuery$data } from "@/modules/patients/detail/laboratory-prescription/ch/components/__generated__/laboratoryTestSelectionLookupQuery.graphql"
import { Language, LanguageValues } from "@/types/__generated__/union-types"
import { ArrElement } from "@/types/ArrElement"

type DocumentLanguage = Exclude<Language, "ITALIAN">

type LaboratoryTest = ArrElement<laboratoryTestSelectionLookupQuery$data["ch_laboratoryExaminationLookups"]> & {
  isPOC: boolean
}

type LaboratoryTestCategory = {
  heading?: string
  options: LaboratoryTest[]
}

type LaboratoryTestSelectionItem = {
  id: string
  isPOC: boolean
}

const DOCUMENT_LANGUAGES: Array<{ value: DocumentLanguage; label: string }> = LanguageValues.filter(
  (l): l is DocumentLanguage => l !== "ITALIAN",
).map((value) => ({ value, label: `common.languageList.${value.toLowerCase()}` }))

const VITAMIN_D_EXAMINATION_CODE = "330"

export {
  type LaboratoryTestCategory,
  type LaboratoryTest,
  type LaboratoryTestSelectionItem,
  DOCUMENT_LANGUAGES,
  VITAMIN_D_EXAMINATION_CODE,
}
